import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {CLIENT_JOURNEY_STATE_IS_LOADING} from '/enum/clientJourneyState.enum';
import {FIRST_WEEK, SECOND_TAB} from '/enum/clientJourneyTasks.enum';
import {
  fetchClientJourneyTask,
  setClientJourneyState,
  setClientJourneyTasks,
} from '/redux/action/client.action';
import {
  clientJourneyTasksByType,
  filteredClientJourneyTasks,
  firstOrderShippingStatusById,
  hasFirstWeekTasks,
} from '/redux/selector/client.selector';
import {allReportData} from '/redux/selector/report.selector';
import {withProps} from '/util/selector.util';

import {FirstWeekTasks} from './FirstWeekTasks';

export default connect(
  createStructuredSelector({
    firstWeekTasks: withProps({type: FIRST_WEEK})(clientJourneyTasksByType),
    firstWeekInitialTasks: withProps({filter: SECOND_TAB})(
      filteredClientJourneyTasks,
    ),
    firstOrderShippingStatus: firstOrderShippingStatusById,
    hasFirstWeekTasks,
    reportData: allReportData,
  }),
  dispatch => ({
    fetchClientJourneyTask: ({clientId, type, task, reportData}: any) =>
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      dispatch(fetchClientJourneyTask({clientId, type, task, reportData})),
    setClientJourneyTasks: ({clientId, type, tasks}: any) =>
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      dispatch(setClientJourneyTasks({clientId, type, tasks})),
    setClientJourneyState: ({clientId, type, stateName, stateValue}: any) =>
      dispatch(
        // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
        setClientJourneyState({
          clientId,
          type,
          stateName,
          stateValue,
        }),
      ),
  }),
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    fetchClientJourneyTask: ({task}: any) => {
      const {clientId} = ownProps;
      const {reportData} = stateProps;

      return dispatchProps.fetchClientJourneyTask({
        clientId,
        type: FIRST_WEEK,
        task,
        reportData,
      });
    },
    setClientJourneyTasks: ({tasks}: any) => {
      const {clientId} = ownProps;
      return dispatchProps.setClientJourneyTasks({
        clientId,
        type: FIRST_WEEK,
        tasks,
      });
    },
    setClientJourneyState: () => {
      const {clientId} = ownProps;
      return dispatchProps.setClientJourneyState({
        clientId,
        type: FIRST_WEEK,
        stateName: CLIENT_JOURNEY_STATE_IS_LOADING,
        stateValue: true,
      });
    },
  }),
)(FirstWeekTasks);
